module.exports = __webpack_public_path__ + "img/logo_primary.b3f45d26.svg";